'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

export function Analytics() {
  const pathname = usePathname();

  useEffect(() => {
    // Google Analytics 4
    if (
      process.env.NODE_ENV === 'production' &&
      process.env.NEXT_PUBLIC_GA_ID
    ) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_ID}`;
      script.async = true;
      document.head.append(script);

      script.addEventListener('load', () => {
        window.gtag =
          window.gtag ||
          (() => {
            (window.gtag as any).q = (window.gtag as any).q || [];
            (window.gtag as any).q.push(arguments);
          });
        window.gtag('js', new Date().toString());
        window.gtag('config', process.env.NEXT_PUBLIC_GA_ID!, {
          page_path: pathname,
        });
      });
    }
  }, [pathname]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && window.gtag) {
      window.gtag('config', process.env.NEXT_PUBLIC_GA_ID!, {
        page_path: pathname,
      });
    }
  }, [pathname]);

  return null;
}
